/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const check_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m1.5 15 6 6 15-18"
    />
  </svg>
)
export default check_medium
